<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.showUser') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center">
            <div class="half-design row">
                <div class="col-12 form-block">
                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">
                        <b-form>
                            <!-- Full Name -->
                            <div class="mb-3 text-left">
                                <label for="fullName" class="mb-1">
                                    {{ $t('title.full_name') }}
                                </label>
                                <b-form-input id="fullName" type="text" v-model="formFields.full_name" disabled></b-form-input>
                            </div>

                            <!-- Email -->
                            <div class="mb-3 text-left">
                                <label for="email" class="mb-1">
                                    {{ $t('title.email') }}
                                </label>
                                <b-form-input id="email" type="text" v-model="formFields.email" disabled></b-form-input>
                            </div>

                            <!-- Phone Number -->
                            <div class="mb-3 text-left">
                                <label for="phone" class="mb-1">
                                    {{ $t('title.phone') }}
                                </label>
                                <b-form-input id="phone" type="text" v-model="formFields.phone" disabled></b-form-input>
                            </div>

                            <!-- Status -->
                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <b-form-input id="status" type="text" v-model="statusLabel" disabled></b-form-input>
                            </div>

                            <!-- Role -->
                            <div class="mb-3 text-left">
                                <label for="role" class="mb-1">
                                    {{ $t('title.SelectRole') }}
                                </label>
                                <b-form-input id="role" type="text" v-model="roleLabel" disabled></b-form-input>
                            </div>

                            <b-button variant="primary" class="mb-3 w-100" @click.prevent="onCancel">
                                {{ $t('title.Back') }}
                            </b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    data() {
        return {
            formFields: {
                full_name: '',
                email: '',
                phone: '',
                status: null,
                role: null,
            },
        };
    },
    computed: {
        statusLabel() {
            return this.formFields.status ? this.$t('title.Active') : this.$t('title.Inactive');
        },
        roleLabel() {
            return this.formFields.role ? this.formFields.role.label : '';
        }
    },
    components: { Breadcrumbs },
    methods: {
        async fetchUserData(id) {
            try {
                const response = await request({ method: 'get', url: `/admin/system-users/${id}` });
                const data = response.data;
                this.formFields.full_name = data.full_name || "";
                this.formFields.email = data.email || "";
                this.formFields.phone = data.phone || "";
                this.formFields.status = data.is_active;
                this.formFields.role = { label: data.roles, value: data.roles };
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        },
        onCancel() {
            this.$router.push({ name: 'Users' });
        }
    },
    mounted() {
        const id = this.$route.params.id;
        if (id) this.fetchUserData(id);
    },
};
</script>
